define('all/support',['jquery', 'all/jquery/jquery.base64'], function($) {
	'use strict';

	if (window.support === undefined) {
		window.support = {};
	}

	var ENTER_CODE = 13;

	window.support = {
        search: function(options, event, nanorepLink) {
            var code = 0, base64SearchString;
            if (event) {
                code = (event.keyCode ? event.keyCode : event.which);
            }
            if (options.click || code === ENTER_CODE) {
                base64SearchString = $.base64.encode($('#support-search').val());

                window.open(this.linkWithCustVars(nanorepLink + base64SearchString), 'knowledgebase', 'width=700, height=500, scrollbars=yes, resizable=yes');
            }
        },

		linkWithCustVars: function(nanorepLink) {
			if (!window.lpCustomVariablesEnabled) {
				return nanorepLink;
			}
			if (playerinfo && playerinfo.info) {
				var params = 'params=';
				if (playerinfo.info.valueSegmentCurrent) {
					params = params +  escape('VSC') + ':' + escape(playerinfo.info.valueSegmentCurrent.substring(0,1));
				}
				if (playerinfo.info.valueSegmentHighest) {
					params = params + ',' + escape('VSH') + ':' + escape(playerinfo.info.valueSegmentHighest.substring(0,1));
				}
				if (params !== 'params=') {
					nanorepLink = nanorepLink + '&' + params;
				}
			}
			return nanorepLink;
		}
	};
	return window.support;
});

